import React from "react";
import PropTypes from "prop-types";
import { classes, useVoltState } from "@mqd/volt-toolbox/src";
import { Content } from "../content/index.js";
import { LeftNav } from "../left-nav/index.js";
import { TNavLinks } from "../left-nav/types.js";
import { SkipLinks } from "../skip-links/index.js";
import { TopBar } from "../top-bar/index.js";
import css from "./page.module.css";
const topBarRef = React.createRef();
const leftNavRef = React.createRef();
const contentRef = React.createRef();
export function Page({
  activePath,
  children,
  className,
  go,
  leftNav = [],
  leftNavHeader,
  loading = false,
  persist,
  pinLeftNav,
  testId,
  title = "",
  topBar
} = {}) {
  const hasLeftNav = Boolean(leftNav?.length);
  const toggleLoading = useVoltState((state) => state.toggleLoading);
  const [voltGo, setGo] = useVoltState((state) => [state.go, state.setGo]);
  const setDom = useVoltState((state) => state.setDom);
  const skipLinks = ["content"];
  if (hasLeftNav)
    skipLinks.unshift("navigation");
  if (typeof pinLeftNav === "undefined")
    pinLeftNav = hasLeftNav;
  React.useEffect(() => {
    setDom({
      topBar: topBarRef,
      leftNav: leftNavRef,
      content: contentRef
    });
  }, [setDom]);
  React.useEffect(() => {
    toggleLoading(loading);
  }, [loading, toggleLoading]);
  React.useEffect(() => {
    if (voltGo !== go) {
      setGo(go);
    }
  }, [go]);
  return /* @__PURE__ */ React.createElement("div", { className: classes(css.page, className), "data-testid": testId, id: "top" }, /* @__PURE__ */ React.createElement(SkipLinks, { links: skipLinks }), topBar && /* @__PURE__ */ React.createElement(TopBar, { ref: topBarRef }, topBar), /* @__PURE__ */ React.createElement("div", { className: css.main }, hasLeftNav && /* @__PURE__ */ React.createElement(
    LeftNav,
    {
      activePath,
      links: leftNav,
      persist,
      pinned: pinLeftNav,
      header: leftNavHeader,
      ref: leftNavRef
    }
  ), /* @__PURE__ */ React.createElement(Content, { ref: contentRef }, children)));
}
Page.propTypes = {
  activePath: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  go: PropTypes.func,
  leftNav: TNavLinks,
  leftNavHeader: PropTypes.node,
  loading: PropTypes.bool,
  persist: PropTypes.bool,
  pinLeftNav: PropTypes.bool,
  testId: PropTypes.string,
  title: PropTypes.string,
  topBar: PropTypes.node
};
Page.defaultProps = {
  leftNav: [],
  loading: false,
  persist: false,
  title: ""
};
